import { PointState } from "../types/PointState";

export const state: PointState = {
    points: null,
    updateIntervalId: null
}
